<template>
  <div style="min-height: 100vh;">
    <!-- {{error}} -->
    <div class="bgc_top">
      <div class="sticky_top">
          <van-sticky>
            <div class="sticky_topOne">
              <!-- <div class="sticky_topthr" @click="goECharge"><img src="../../assets/Arrow.png" alt=""></div> -->
              <div class="searchCell">
                <van-search
                  shape="round"
                  background="#F41B38"
                  placeholder="搜索商品"
                  disabled
                  @click="goSearch"
                />
              </div>
            </div>
          </van-sticky>
      </div>
      <div class="absoliute">
        <van-swipe :autoplay="5000">
          <van-swipe-item
            v-for="(image, index) in imgUrls"
            :key="index"
            @click="goSwiper(image,image.productCategoryId, image.name, image.url)"
          >
            <img v-lazy="image.pic" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="margin">
      </div>
      <div class="dienterprises">
        <img src="@/assets/enterprises.png" @click="enterprisesClick(1,'名企精选',0)" alt="">
        <!-- 搜精品精选 -->
        <img src="@/assets/prevention.png" alt="" @click="enterprisesClick(93,'疫情防护',1)">
        <img src="@/assets/Poverty.png" alt="" @click="enterprisesClick(31,'9.9元拼',2)">
      </div>
      <div class="dienterprisesTthe">
        <img src="@/assets/Boutique.png" alt="" @click="enterprisesClick(itemGroup[1].productCategoryId,itemGroup[1].name,3)">
        <img src="@/assets/region.png" alt="" @click="enterprisesClick(21,'地域精品',4)">
        <!-- activ -->
      </div>
      <div class="listHomepage" v-for="(item,index) in ListHomepage" :key="index">
          <img :src="item.pic" alt="" @click="goAdvertising(item,item.productCategoryId, item.name, item.url)">
      </div>
      <div class="epidemic" @click="goCoupon">
        <img src="@/assets/envelopes.png" alt="">
      </div>
      <!-- <van-list v-model="loading" :finished="finished" loading-text="正在加载中..." :error.sync="error" error-text="请求失败，点击重新加载" finished-text="我是有底线的哦 ~ " @load="onLoad" :offset="ofass">上拉加载 -->
      <div class="container-water-fall water-content ">
        <!-- <p class="after">11111111111111111111111111111111</p> -->
        <waterfall :col="col"
                  :data="data" @loadmore = loadmore :finish="finished" :loadDistance="500" @scroll="scroll" isTransition >
          <template>
            <div class="cell-item"
                v-for="(item,index) in data"
                :key="index" @click="wateritem(item.id,item)" v-cloak>
              <img v-if="item.pic"
                  :src="item.pic"
                  :lazy-src="item.pic"
                  alt="加载错误" v-cloak>
              <div class="item-body">
                <div class="item-desc"></div>
                <div class="item-footer">
                  <div class="item-footerTop">
                    <span class="supplierCode" v-if="item.supplierCode==='ZY'">自营</span>
                    <span :class="item.supplierCode==='ZY'?'name':'namea'">{{item.name}}</span>
                  </div>
                  <div class="marginpriceTop">
                    <div style="padding-top:3px;">
                      <span style="color:#FF4141;">￥</span>
                      <span class="priceTop">{{item.price}}</span>
                    </div>
                    <div class="Cart" >
                      <img src="@/assets/cart.png" alt="" class="ImgCart">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- <loading :show="loading"/> -->
        </waterfall>
          <div class="isLoadingTrue"  v-show="finished">
            <van-loading /><span>正在加载中...</span>
          </div>
          <div class="index"></div>
      </div>
      <!-- </van-list> -->
    </div>
  </div>
</template>
<script>
import { Search, Sticky, Swipe, SwipeItem, Toast, List, Loading } from 'vant'
import { apiHome, activityList, productInfo, addcartItem, postToken } from '../../request/api.js'
import { Debounce2 } from '@/utils/onload'
// import loading from '@/components/load'
export default {
  components: {
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    [Swipe.name]: Swipe,
    [List.name]: List,
    [SwipeItem.name]: SwipeItem,
    [Toast.name]: Toast,
    [Loading.name]: Loading
    // loading
  },
  props: {
    title: String
  },
  watch: {
    // data (newName, oldName) {
    //   console.log(newName.length, oldName.length)
    //   if (newName.length > oldName.length) {
    //     this.gotocomm = true
    //     console.log(newName.length, oldName.length)
    //   }
    // }
  },
  data() {
    return {
      // error: '',
      imgUrls: [],
      data: [],
      col: 2,
      itemGroup: [],
      pageNum: 0,
      code: 0,
      activiteWhole: {},
      loadinga: false,
      gotocomm: false,
      finished: false,
      ListHomepage: []
    }
  },
  computed: {
    itemWidth() {
      console.log(353 * 0.5 * (document.documentElement.clientWidth / 375))
      return 353 * 0.5 * (document.documentElement.clientWidth / 375)
    }
    // gutterWidth() {
    //   console.log(9 * 0.5 * (document.documentElement.clientWidth / 375))
    //   return (9 * 0.5 * (document.documentElement.clientWidth / 375))
    // }
  },
  activated() {
    document.documentElement.scrollTop = this.scrollTop
    // sessionStorage.getItem('scrollTop')
    this.onLoad()
  },
  methods: {
    // goECharge() {
    //   window.history.go(-1)
    // },
    scroll(scrollData) {
      // console.log(scrollData)
      this.scrollTop = scrollData.scrollTop
    },
    goSearch () {
      this.$router.push({ path: '/search' })
    },
    goCoupon() {
      this.$router.push('/couponlist')
    },
    loadmore() {
      this.onLoad()
    },
    // data
    indexData () {
      const _this = this
      apiHome()
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            Toast.clear()
            _this.imgUrls = res.data.advertiseList
            _this.itemGroup = res.data.floorList
            _this.activiteWhole = res.data.activityListWhole
            _this.ListHomepage = res.data.advertiseListHomepage
          }
        })
        .catch(err => {
          console.log(err)
          setTimeout(() => {
            Toast.clear()
            Toast.fail('网络错误')
          }, 5000)
        })
    },
    enterprisesClick(status, name, i) {
      console.log(status, name, i)
      if (i === 0) {
        this.$router.push({
          path: '/classification',
          query: { tabStatus: status, name: name }
        })
      } else if (i === 1 || i === 2 || i === 4) {
        this.$router.push({
          path: '/classification',
          query: { activityId: status, name: name }
        })
      } else if (i === 3) {
        this.$router.push({
          path: '/classification',
          query: { Roll: status, name: name }
        })
      }
      // console.log(status, name)
      // const productCategoryId = (status + '').substring(0, 2)
      // this.$router.push({
      //   path: '/classification',
      //   query: { Roll: productCategoryId, name: name }
      // })
    },
    goSwiper (item, id, name, url) {
      console.log(item, id, name, url)
      if (item.useType === 0) {
        const productCategoryId = (id + '').substring(0, 2)
        this.$router.push({
          path: '/classification',
          query: { Roll: id, ID: productCategoryId, name: name }
        })
      } else if (item.useType === 1) {
        // window.open(item.url, '_blank')
        this.$router.push({ path: '/active1', query: { id: item.activityId, name: name } })
      } else if (item.useType === 2) {
        this.$router.push({
          path: '/searchList',
          query: { keywords: '', id: item.activityId, pic: url, name: name, productNum: item.productNum }
        })
      }
      // console.log((id + '').substring(0, 2))
    },
    // 广告位
    goAdvertising(item, id, name, url) {
      console.log(item, id, name, url)
      if (item.useType === 0) {
        const productCategoryId = (id + '').substring(0, 2)
        this.$router.push({
          path: '/classification',
          query: { Roll: id, ID: productCategoryId, name: name }
        })
      } else if (item.useType === 1) {
        this.$router.push({ path: '/active1', query: { id: item.activityId, name: name } })
      } else if (item.useType === 2) {
        this.$router.push({
          path: '/Advertising',
          query: { keywords: '', id: item.activityId, pic: url, name: name, productNum: item.productNum }
        })
      }
    },
    wateritem(id, item) {
      console.log(event.target.className)
      console.log(id, item)
      if (event.target.className !== 'ImgCart animation') {
        this.$router.push({ path: '/CommodityDetails', query: { id: id, skuId: item.defaultSkuId } })
        // this.$router.push(`/CommodityDetails/${id}?skuId=${item.defaultSkuId}`)
        console.log(this.loadinga)
      } else {
        productInfo(id).then(res => {
          console.log(res)
          return res.data.skuStockList[0]
        }).then(res => {
          addcartItem({
            productId: res.productId,
            productSkuId: res.id,
            quantity: 1
          }).then(res => {
            if (res.code === 200) {
              Toast.success(res.message)
              if (res.data === 'N') {
                this.code++
                sessionStorage.setItem('code', this.code)
              }
            } else {
              Toast.fail(res.message)
            }
            console.log(res)
          }).catch(res => {
            console.log(res)
          })
        })
      }
    },
    onLoad: Debounce2(function() {
      this.loadinga = true
      this.finished = false
      this.pageNum += 1
      const params = {
        pageSize: 12,
        pageNum: this.pageNum,
        tabStatus: 3
      }
      console.log(params)
      activityList(params).then(res => {
        console.log(res, 'res')
        if (res.code === 200) {
          this.data = this.data.concat(res.data.list)
          this.loadinga = false
          this.finished = true
          if (this.data.length === res.data.total) {
            this.loadinga = true
            this.finished = false
          }
          // console.log(this.loadinga)
          // console.log(this.finished)
          // console.log(this.gotocomm)
        }
      }).catch(res => {
        console.log(res)
      })
    }, 1000)
  },
  created () {
    console.log(window.performance.navigation.type)
    var url = location.href
    var param = url.split('?')[1] // 获取param
    if (param) {
      var arr = param.split('&')
      var obj = {}
      for (let i = 0; i < arr.length; i++) {
        var newObj = arr[i].split('=')
        obj[newObj[0]] = newObj[1]
      }
      var objNum = Object.keys(obj)
      // alert(objNum.length === 0) // true 为空， false 不为空
      if (objNum.length !== false) {
        const params = {
          requestId: obj.requestId,
          accessKey: obj.accessKey
        }
        localStorage.setItem('requestId', obj.requestId)
        console.log(localStorage.getItem('requestId'))
        console.log(obj)
        postToken(params).then(res => {
          console.log(res)
          if (res.code === 200) {
            localStorage.setItem('token', res.data)
          }
          console.log()
        }).catch(err => {
          console.log(err)
        })
      }
    // localStorage.setItem('objData', JSON.stringify(obj))
    // // console.log(JSON.parse(localStorage.getItem('objData')))
    // if (obj.token !== undefined) {
    //   localStorage.setItem('token', obj.token)
    // }
    }
    Toast.loading({
      duration: 0, // 持续展示 toast
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner'
    })
    this.indexData()
  }
}
</script>
<style lang="less" scoped>
.bgc_top{
  background-color: #F2F2F2;
  position: relative;
}
@widthframe: 720px;
    /deep/ .van-search {
      width: @widthframe;
      height: 64px;
      padding: 0;
      margin-left: 15px;
    }
    .sticky_top{
      width: 750px;
      height: 354px;
      background-color: #F41B38;
      .sticky_topOne{
        padding: 12px 0px;
        display: flex;
        background-color: #F41B38;
        justify-content: flex-start;
        align-items: center;
      }
      .sticky_topthr{
        width: 17px;
        height: 32px;
        padding-left: 27px;
        padding-right: 20px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  /deep/ .van-search__content--round {
    border-radius:30px
  }
.van-swipe {
  width: @widthframe;
  height: 320px;
  border-radius: 10px;
  margin: 20px auto;
  overflow: hidden;
  background: #fff;
  /deep/ .van-swipe__indicator {
    width: 16px;
    height: 16px;
    margin: 0 6px;
  }
  img {
    width: @widthframe;
    height: 320px;
  }
}
.absoliute{
  position: absolute;
  top: 65px;
  left: 15px;
}
.welfare{
  width: @widthframe;
  height: 160px;
  margin: 16px auto;
  background: url('../../assets/situation.png') no-repeat;
  background-size: 100% 100%;
  border-radius: 5px;
}
.epidemic{
  width: @widthframe;
  height: 160px;
  margin: 14px auto;
  margin-bottom: 3px;
  background: url('../../assets/situation.png') no-repeat;
  background-size: 100% 100%;
  border-radius: 5px;
  position: relative;
  img{
    width: 284px;
    height: 153px;
    position: absolute;
    bottom: -7px;
    right: -6px;
  }
}
.dienterprises{
  width: @widthframe;
  display: flex;
  justify-content: space-between;
  margin-left: 15px;
  img{
    width: 230px;
    height: 130px;
  }
}
.margin{
  height: 65px;
}
.dienterprisesTthe{
  width: @widthframe;
  display: flex;
  justify-content: space-between;
  margin-left: 15px;
  margin-top: 10px;
  img{
    width: 355px;
    height: 130px;
  }
}
.container-water-fall {
  // padding: 0 28px;
  box-sizing: border-box;
  &.water-content {
    margin: 0 15px;
  }
  .cell-item {
    width: 100%;
    background: #ffffff;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 16px;
    margin-top: 10px;
    img {
      // border-radius: 12px 12px 0 0;
      width: 100%;
      height: auto;
      display: block;
    }
    .item-body {
      // border: 1px solid #F0F0F0;
      padding: 12px;
      padding-bottom: 18px;
      .item-desc {
        font-size: 15px;
        color: #333333;
        font-weight: bold;
      }
      .item-footer {
        .item-footerTop {
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          .supplierCode{
            background:#E33F36;
            border-radius:4px;
            padding: 1px 10px;
            color: white;
            font-size: 24px;
          }
          .name{
            padding-left: 15px;
            font-size: 28px;
            color: #333333;
          }
          .namea{
            font-size: 28px;
            color: #333333;
          }
        }
        .marginpriceTop{
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          .priceTop{
            color: #FF4141;
            font-size: 36px;
          }
          .Cart{
            margin-top: 4px;
            width: 42px;
            height: 42px;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
.vue-waterfall /deep/.vue-waterfall-column {
  width: 49% !important;
  margin-right: 2%;
}
.vue-waterfall /deep/.vue-waterfall-column:last-child {
  width: 49% !important;
  margin-right: 0;
}
/deep/ .van-field__control{
  font-size: 26px;
  padding-top: 8px;
}
/deep/ .van-icon-search{
  font-size: 36px;
  padding-top: 8px !important;
}
.isLoadingTrue{
  height: 60px;
  background: #F2F2F2;
  text-align: center;
  padding-top: 20px;
}
.index{
  background-color: #F2F2F2;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 1000px;
  width: 100%;
  z-index: -9999;
}
/deep/.van-swipe__indicator{
  background-color: #1989fa;
}
[v-cloak] {
  display: none;
}
.listHomepage{
  width: @widthframe;
  height:160px;
  border-radius:8px;
  margin: 14px auto;
  img{
    width: 100%;
    height: 100%;
  }
}
.searchCell /deep/ .van-search .van-cell {
    // padding: 5px 8px 5px 0;
    font-size: 14px;
    line-height: 42px
}
</style>
